// Mock data for AKT Designs Pvt Ltd website

export const companyInfo = {
  name: "AKT Designs Pvt Ltd",
  tagline: "Transforming Spaces, Elevating Lives",
  description: "We are a premier interior design firm specializing in creating stunning residential and commercial spaces that reflect your unique style and personality.",
  logo: "https://customer-assets.emergentagent.com/job_789ae489-29b7-42bb-9a6e-99bb7b83a46d/artifacts/zs9n11yy_IMG-20260125-WA0000.jpg",
  phone: "+91 7086107661",
  email: "info@aktdesigns.live",
  address: "Anguri Chariali, Chipahi Road, Sivasagar-785640, Assam",
  social: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
    pinterest: "#"
  }
};

export const services = [
  {
    id: 1,
    title: "Residential Design",
    description: "Transform your home into a sanctuary with our bespoke residential interior design services tailored to your lifestyle.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Commercial Spaces",
    description: "Create inspiring workspaces that boost productivity and reflect your brand identity with our commercial design expertise.",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Space Planning",
    description: "Maximize your space potential with our strategic space planning solutions that optimize flow and functionality.",
    icon: "LayoutGrid"
  },
  {
    id: 4,
    title: "Renovation & Remodeling",
    description: "Breathe new life into existing spaces with our comprehensive renovation and remodeling services.",
    icon: "Hammer"
  },
  {
    id: 5,
    title: "Furniture Design",
    description: "Custom furniture pieces designed and crafted to perfectly complement your interior aesthetic.",
    icon: "Sofa"
  },
  {
    id: 6,
    title: "Lighting Design",
    description: "Illuminate your spaces with expertly designed lighting solutions that create the perfect ambiance.",
    icon: "Lightbulb"
  }
];

export const projects = [
  {
    id: 1,
    title: "Modern Luxury Villa",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NjkzMjc0MDB8MA&ixlib=rb-4.1.0&q=85",
    location: "Gurugram"
  },
  {
    id: 2,
    title: "Contemporary Living Room",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc2OTMyNzQwNXww&ixlib=rb-4.1.0&q=85",
    location: "Delhi"
  },
  {
    id: 3,
    title: "Elegant Bathroom Suite",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1581783458534-001a466b5487?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NjkzMjc0MDF8MA&ixlib=rb-4.1.0&q=85",
    location: "Noida"
  },
  {
    id: 4,
    title: "Cozy Modern Space",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc2OTMyNzQwNXww&ixlib=rb-4.1.0&q=85",
    location: "Mumbai"
  },
  {
    id: 5,
    title: "Luxury Fireplace Lounge",
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1581784878214-8d5596b98a01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NjkzMjc0MDB8MA&ixlib=rb-4.1.0&q=85",
    location: "Bangalore"
  },
  {
    id: 6,
    title: "Bright Living Space",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc2OTMyNzQwNXww&ixlib=rb-4.1.0&q=85",
    location: "Pune"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Homeowner, Guwahati",
    image: "https://images.unsplash.com/photo-1735845929510-48e0ecdb53d2?w=150&h=150&fit=crop&crop=face",
    quote: "AKT Designs transformed our house into a dream home. Their attention to detail and understanding of our vision was exceptional. Highly recommended!",
    rating: 5
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    role: "CEO, TechStart Solutions",
    image: "https://images.unsplash.com/photo-1612531386530-97286d97c2d2?w=150&h=150&fit=crop&crop=face",
    quote: "Our new office space has completely changed the way our team works. The design perfectly reflects our brand values and boosts productivity.",
    rating: 5
  },
  {
    id: 3,
    name: "Anita Desai",
    role: "Restaurant Owner",
    image: "https://images.unsplash.com/photo-1759840278511-f73a3d62fb9f?w=150&h=150&fit=crop&crop=face",
    quote: "The ambiance AKT created for our restaurant has been praised by every customer. They truly understand how to create memorable spaces.",
    rating: 5
  }
];

export const stats = [
  { value: "500+", label: "Projects Completed" },
  { value: "15+", label: "Years Experience" },
  { value: "50+", label: "Design Awards" },
  { value: "100%", label: "Client Satisfaction" }
];

export const navLinks = [
  { name: "Home", href: "#home" },
  { name: "Services", href: "#services" },
  { name: "Portfolio", href: "#portfolio" },
  { name: "About", href: "#about" },
  { name: "Blog", href: "/blog", isRoute: true },
  { name: "Testimonials", href: "#testimonials" },
  { name: "Contact", href: "#contact" }
];
